var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tag",class:{
      'has-text-light': _vm.hasTextLight,
      pointer: _vm.clickable,
     },style:(`background: ${_vm.tag.color};`)},[_c('span',{staticClass:"is-uppercase",on:{"click":_vm.handleClick}},[_vm._v(_vm._s(_vm.tag.name))]),(_vm.closable)?_c('span',{staticClass:"close",on:{"click":_vm.handleClose}},[_c('BIcon',{attrs:{"icon":"times"}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }